import React from 'react';
import SideBar from './common/SideBar';
import Header from './common/Header';
import Footer from './common/Footer';
import Center from './components/Center';

function App() {
  return (
    <div>
      <SideBar />
      <Header />
      <Center />
      <Footer />
    </div>
  );
}

export default App;
